// Multi-brand configuration. Selected at build time via REACT_APP_SITE_BRAND.
//
//  mgv          — default MGV Gallery (full catalogue)
//  chefkunming  — food / private-chef focused site (single groundtruth data,
//                 same backend as mgv + visit-kunming)
//  visitkunming — Kunming travel & dining site
//
// Each brand declares its public origin and an optional `sister` site so the
// cross-domain SSO ("log in on the sister site too") can be wired automatically.
// Runtime hostname -> brand override.
//
// The built bundle is SHARED across domains: mgv.gallery, openbadge.me and the
// Kunming sites all serve the same /home/www/site/current build, so the
// build-time REACT_APP_SITE_BRAND is always 'mgv'. Per-domain chrome
// differences (nav, footer, cart) are therefore resolved at RUNTIME from
// window.location.hostname. Build-time brand still wins when no hostname
// matches (dev, or a new host that has not been registered here yet).
const HOST_BRANDS = {
  'openbadge.me': 'openbadge',
};

function resolveBrandKey() {
  if (typeof window !== 'undefined' && window.location && window.location.hostname) {
    const host = window.location.hostname.toLowerCase().replace(/^www\./, '');
    if (HOST_BRANDS[host]) return HOST_BRANDS[host];
  }
  return process.env.REACT_APP_SITE_BRAND || 'mgv';
}

const BRAND_KEY = resolveBrandKey();

const BRANDS = {
  mgv: {
    key: 'mgv',
    siteName: 'MGV Gallery',
    siteNameShort: 'MGV',
    origin: process.env.REACT_APP_SITE_ORIGIN || 'http://47.108.215.19',
    sister: null,
    hiddenHospitality: [],
    diningFocus: false,
    tagline: 'Excellence in service and unforgettable experiences.',
    heroImage: '/assets/images/hospitality/hero-hospitality.jpg',
  },
  chefkunming: {
    key: 'chefkunming',
    siteName: 'Chef Kunming',
    siteNameShort: 'Chef Kunming',
    origin: process.env.REACT_APP_SITE_ORIGIN || 'https://chefkunming.com',
    sister: {
      key: 'visitkunming',
      name: 'Visit Kunming',
      origin: 'https://visit-kunming.com',
    },
    // Focus on catering / private chef; de-emphasise other hospitality lines.
    hiddenHospitality: ['event', 'stay'],
    diningFocus: true,
    tagline: 'Private chefs & curated catering in Kunming.',
    heroImage: '/assets/images/hospitality/catering.jpg',
  },
  visitkunming: {
    key: 'visitkunming',
    siteName: 'Visit Kunming',
    siteNameShort: 'Visit Kunming',
    origin: process.env.REACT_APP_SITE_ORIGIN || 'https://visit-kunming.com',
    sister: {
      key: 'chefkunming',
      name: 'Chef Kunming',
      origin: 'https://chefkunming.com',
    },
    hiddenHospitality: [],
    diningFocus: true,
    tagline: 'Discover Kunming — food, culture, and stays.',
    heroImage: '/assets/images/hospitality/hero-hospitality.jpg',
  },
  // openbadge.me — same shared build as mgv, but NO service catalogue and NO
  // shopping cart. Its footer is driven by `footerColumns` (categorised link
  // columns) instead of the default Services/Company layout.
  openbadge: {
    key: 'openbadge',
    siteName: 'OpenBadge',
    siteNameShort: 'OpenBadge',
    origin: 'https://openbadge.me',
    sister: null,
    hiddenHospitality: [],
    diningFocus: false,
    // Strip the service dropdown from the nav and the whole cart/checkout flow.
    showServices: false,
    showCart: false,
    // openbadge.me is a profile-only site: only agent profiles, no other MGV components.
    profileOnly: true,
    // Copyright holder name (interpolated into footer.copyright as {{name}}).
    copyrightName: 'openbadge',
    // Categorised footer link columns (translation keys resolved in Footer.js).
    footerColumns: [
      {
        titleKey: 'footer.company',
        titleFallback: 'Company',
        links: [
          { nameKey: 'common.about', nameFallback: 'About', path: '/about' },
          { nameKey: 'common.careers', nameFallback: 'Careers', path: '/careers' },
        ],
      },
    ],
    tagline: 'Excellence in service and unforgettable experiences.',
    heroImage: '/assets/images/hospitality/hero-hospitality.jpg',
  },
};

export const brand = BRANDS[BRAND_KEY] || BRANDS.mgv;
export { BRAND_KEY };
export default brand;
